import { ContentFormat } from '../../api/api.ts';
import { stripHtml } from 'string-strip-html';
import cn from '../../utils/cn.ts';
import { useMemo } from 'react';

export default function DescriptionView({
  content,
  format,
  lang,
  cutoff = 120,
}: {
  content: string | null;
  format: ContentFormat;
  lang: 'de' | 'en';
  cutoff?: number;
}) {
  const contentStripped = useMemo(() => {
    return format === ContentFormat.Html
      ? stripHtml(content || '').result
      : content || '';
  }, [format, content]);

  return (
    <div>
      {lang === 'en' ? '🇺🇸' : '🇩🇪'}&nbsp;
      <span
        className={cn('text-[.7em]', 'p-[2px]', 'rounded-[2px]', 'bg-gray-300')}
      >
        {format.toUpperCase()}
      </span>
      &nbsp;
      {(contentStripped.length > 0 && (
        <>
          {contentStripped.substring(0, cutoff)}
          {contentStripped.length > cutoff ? <>&hellip;</> : null}{' '}
          <span className={cn('text-[.7em]')}>
            [{contentStripped.length} chars]
          </span>
        </>
      )) || (
        <span className={cn('text-[.7em]', 'italic', 'text-blue-500')}>
          -empty-
        </span>
      )}
    </div>
  );
}
